import { render, staticRenderFns } from "./prePayment.vue?vue&type=template&id=34983436&scoped=true&"
import script from "./prePayment.vue?vue&type=script&lang=js&"
export * from "./prePayment.vue?vue&type=script&lang=js&"
import style0 from "./prePayment.vue?vue&type=style&index=0&id=34983436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34983436",
  null
  
)

export default component.exports